import { defineComponent, h } from 'vue'

const PassthroughStandalone = defineComponent({
  name: 'XappAuthPassthroughStandalone',
  setup(_, { slots }) {
    return () => h('div', {}, slots.default ? slots.default() : [])
  },
})

const standaloneState = {
  component: PassthroughStandalone,
}

export function setAuthStandaloneAdapter(component) {
  standaloneState.component = component || PassthroughStandalone
}

export function useAuthStandaloneAdapter() {
  return standaloneState.component
}
